export enum NewsKategorie {
    WERBUNG = "WERBUNG",
    GESETZLICHEINFO = "GESETZLICHEINFO"
}